import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { yuebaoApi } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
/***
 * created by 六月
 * 余额宝 相关接口
 * 2022-05-18
 *
 */
export var YuebaoService = /*#__PURE__*/function (_BaseResource) {
  _inherits(YuebaoService, _BaseResource);
  var _super = _createSuper(YuebaoService);
  function YuebaoService() {
    _classCallCheck(this, YuebaoService);
    return _super.apply(this, arguments);
  }
  _createClass(YuebaoService, [{
    key: "getYuebaoInfo",
    value:
    // 查询用户余额宝信息
    function getYuebaoInfo() {
      return this.requester.get(yuebaoApi.info);
    }
    // 转入
  }, {
    key: "transferIn",
    value: function transferIn(money) {
      return this.requester.post(yuebaoApi.transferIn, {
        money
      });
    }
    // 转出
  }, {
    key: "transferOut",
    value: function transferOut(param) {
      return this.requester.post(yuebaoApi.transferOut, param);
    }
    // 查询历史收益
  }, {
    key: "interestHistory",
    value: function interestHistory(param) {
      return this.requester.get(yuebaoApi.interestHistory, param);
    }
  }]);
  return YuebaoService;
}(BaseResource);